// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__12VC4","buttons":"RemoveExpirationActionButtons_buttons__2lnDw"};